import React, { useEffect, useState } from "react";
import EmailEditor from "react-email-editor";
import { EditorContainer } from "./Theme";
import { fontConfig } from "theme/fontConfig";

const IMAGE_NAME_ERROR =
  "Image upload failed. Remove apostrophes or semicolons from the file name.";
// ponytail: Unlayer has no filename list. ' and ; drop the image; spaces are allowed.
const isBadImageName = (name) => /[';]/.test(name || "");

const Editor = ({
  setJsonContent,
  setHtmlContent,
  preview,
  jsonContent = {},
  tokenList,
  emailEditorRef,
  
}) => {
  const [uploadError, setUploadError] = useState("");
  const applyImageName = (name) => {
    if (!name) return;
    setUploadError(isBadImageName(name) ? IMAGE_NAME_ERROR : "");
  };
  const exportContent = () => {
    emailEditorRef.current.editor.exportHtml((data) => {
      const { design, html } = data;
      setHtmlContent(html);
      setJsonContent(design);
    });
  };
  if (!jsonContent || !Object?.keys(jsonContent).length) jsonContent = {
    "counters": {
      "u_column": 1,
      "u_row": 1,
      "u_content_image": 2,
      "u_content_text": 1
    },
    "body": {
      "id": "ldQMDGIGGe",
      "rows": [
        {
          "id": "feicPZF9Fh",
          "cells": [
            1
          ],
          "columns": [
            {
              "id": "tkcEbUU4k6",
              "contents": [
                {
                  "id": "0xSznf8hdb",
                  "type": "text",
                  "values": {
                    "containerPadding": "10px",
                    "anchor": "",
                    "fontSize": "14px",
                    "textAlign": "left",
                    "lineHeight": "140%",
                    "linkStyle": {
                      "inherit": true,
                      "linkColor": "#0000ee",
                      "linkHoverColor": "#0000ee",
                      "linkUnderline": true,
                      "linkHoverUnderline": true
                    },
                    "displayCondition": null,
                    "_meta": {
                      "htmlID": "u_content_text_1",
                      "htmlClassNames": "u_content_text"
                    },
                    "selectable": true,
                    "draggable": true,
                    "duplicatable": true,
                    "deletable": true,
                    "hideable": true,
                    "text": "<p style=\"line-height: 140%;\">This is a new Text block. Change the text.</p>"
                  }
                }
              ],
              "values": {
                "backgroundColor": "",
                "padding": "0px",
                "borderRadius": "0px",
                "_meta": {
                  "htmlID": "u_column_1",
                  "htmlClassNames": "u_column"
                }
              }
            }
          ],
          "values": {
            "displayCondition": null,
            "columns": false,
            "backgroundColor": "",
            "columnsBackgroundColor": "",
            "backgroundImage": {
              "url": "",
              "fullWidth": true,
              "repeat": "no-repeat",
              "size": "custom",
              "position": "center",
              "customPosition": [
                "50%",
                "50%"
              ]
            },
            "padding": "0px",
            "anchor": "",
            "hideDesktop": false,
            "_meta": {
              "htmlID": "u_row_1",
              "htmlClassNames": "u_row"
            },
            "selectable": true,
            "draggable": true,
            "duplicatable": true,
            "deletable": true,
            "hideable": true
          }
        }
      ],
      "headers": [],
      "footers": [],
      "values": {
        "popupPosition": "center",
        "popupWidth": "600px",
        "popupHeight": "auto",
        "borderRadius": "10px",
        "contentAlign": "center",
        "contentVerticalAlign": "center",
        "contentWidth": "500px",
        "fontFamily": {
          "label": "Arial",
          "value": "arial,helvetica,sans-serif"
        },
        "textColor": "#000000",
        "popupBackgroundColor": "#FFFFFF",
        "popupBackgroundImage": {
          "url": "",
          "fullWidth": true,
          "repeat": "no-repeat",
          "size": "cover",
          "position": "center"
        },
        "popupOverlay_backgroundColor": "rgba(0, 0, 0, 0.1)",
        "popupCloseButton_position": "top-right",
        "popupCloseButton_backgroundColor": "#DDDDDD",
        "popupCloseButton_iconColor": "#000000",
        "popupCloseButton_borderRadius": "0px",
        "popupCloseButton_margin": "0px",
        "popupCloseButton_action": {
          "name": "close_popup",
          "attrs": {
            "onClick": "document.querySelector('.u-popup-container').style.display = 'none';"
          }
        },
        "backgroundColor": "#F7F8F9",
        "preheaderText": "",
        "linkStyle": {
          "body": true,
          "linkColor": "#0000ee",
          "linkHoverColor": "#0000ee",
          "linkUnderline": true,
          "linkHoverUnderline": true
        },
        "backgroundImage": {
          "url": "",
          "fullWidth": true,
          "repeat": "no-repeat",
          "size": "custom",
          "position": "center"
        },
        "_meta": {
          "htmlID": "u_body",
          "htmlClassNames": "u_body"
        }
      }
    },
    "schemaVersion": 16
  }
  const loadInitialContent = () => {
    emailEditorRef.current.editor.loadDesign(jsonContent);
  };
  const handleDesignUpdate = () => {
    const unlayer = emailEditorRef.current?.editor;
    if (unlayer) {
      unlayer.addEventListener("design:updated", () => {
        exportContent();
      });
    }
  };

  const onLoad = () => {
    handleDesignUpdate();
    togglePreview();
    loadInitialContent();
  };
  const onReady = (unlayer) => {
    if (!unlayer) return;
    const onUploaded = (data, done) => {
      applyImageName((data && data.image && data.image.filename) || "");
      if (done) done(data);
    };
    if (unlayer.registerCallback) unlayer.registerCallback("image:uploaded", onUploaded);
    if (unlayer.addEventListener) unlayer.addEventListener("image:uploaded", (data) => onUploaded(data));
  };
  const togglePreview = () => {
    const unlayer = emailEditorRef.current?.editor;
    if (preview) {
      unlayer.hidePreview();
    } else {
      unlayer.showPreview("desktop");
    }
  };

  useEffect(() => {
    const unlayer = emailEditorRef.current?.editor;
    if (unlayer) {
      togglePreview();
    }
  }, [preview]);



  return (
    <EditorContainer>
      {uploadError ? (
        <div
          style={{
            background: "#fdecea",
            color: "#b71c1c",
            fontSize: 13,
            padding: "10px 12px",
            marginBottom: 8,
            borderRadius: 4,
          }}
        >
          {uploadError}
        </div>
      ) : null}
      <EmailEditor
        ref={emailEditorRef}
        onLoad={onLoad}
        onReady={onReady}
        options={{
          id: "editor-container",
          projectId: 195575,
          displayMode: "email",
          mergeTags: tokenList?.length ? tokenList : false,
        }}
        style={{
          fontFamily: fontConfig.EditorEmailEditorFont.family,
        }}
      />

    </EditorContainer>
  );
};

export default Editor;
